import { Pagination } from '@store/common/pagination.model';
import { TableFilter, TableFilterType } from '@store/common/tableFilter.model';
import { DocumentKind } from '@store/files';
import { OrganisationLight, OrganisationUnitLight } from '@store/common/organisation.model';
import { OrganisationType } from '@store/common/organisation.enums';
import { Execution } from '@store/operations/executions';
import { Issue } from '@store/operations/issues';

export interface DocumentsFilters {
  search: string;
  importDate?: Date;
  documentKind?: DocumentKind;
  tableFilters: TableFilter[];
}

export namespace DocumentsFilters {
  export const initTableFilters = (clientId?: string, supplierId?: string, clientUnitId?: string, supplierUnitId?: string) => TableFilterType.initTableFilters([
    TableFilterType.CLIENT_ORGANISATION,
    TableFilterType.CLIENT_ORGANISATION_UNIT,
    TableFilterType.SUPPLIER_ORGANISATION,
    TableFilterType.SUPPLIER_ORGANISATION_UNIT,
  ]).map((f) => {
    console.log('f: ', f);
    return ({
      ...f,
      hide: (!!clientId && [TableFilterType.CLIENT_ORGANISATION, TableFilterType.SUPPLIER_ORGANISATION, TableFilterType.SUPPLIER_ORGANISATION_UNIT].includes(f.type))
        || (!!supplierId && [TableFilterType.SUPPLIER_ORGANISATION, TableFilterType.CLIENT_ORGANISATION, TableFilterType.CLIENT_ORGANISATION_UNIT].includes(f.type)),
      values: (f.type === TableFilterType.CLIENT_ORGANISATION && !!clientId) ||
        (f.type === TableFilterType.SUPPLIER_ORGANISATION && !!supplierId) ||
        (f.type === TableFilterType.CLIENT_ORGANISATION_UNIT && !!clientUnitId) ||
        (f.type === TableFilterType.SUPPLIER_ORGANISATION_UNIT && !!supplierUnitId) ? [{
          label: '',
          value: clientId || supplierId || clientUnitId || supplierUnitId
        }] : [],
    });
  });
}

export interface DocumentsPagination extends Pagination {
  data: Document[];
}

export interface ManageDocument extends Partial<Document> {
  organisationType?: OrganisationType;
  organisation?: OrganisationLight;
  organisationUnit?: OrganisationUnitLight;
  documentFile?: File;
  adminDocumentId?: number;
}

export namespace ManageDocument {
  export const fromDocument = (document: Document) => {
    return {
      ...document,
      organisation: { id: document.organisationId, name: document.organisationName },
      organisationUnit: { id: document.organisationUnitId, name: document.organisationUnitName },
      startValidity: document.startValidity ? new Date(document.startValidity) : undefined,
      endValidity: document.endValidity ? new Date(document.endValidity) : undefined,
    };
  };
}

export namespace Document {
  export const toFormData = (document: ManageDocument): FormData => {
    const newFormData = new FormData();

    if (document.documentFile) newFormData.append('document', document.documentFile);
    if (document.documentKind) newFormData.append('documentKind', document.documentKind);
    if (document.organisationType) newFormData.append('organisationType', document.organisationType);
    if (document.organisation?.id) newFormData.append('organisation', `${document.organisation.id}`);
    if (document.organisationUnit?.id) newFormData.append('organisationUnit', `${document.organisationUnit.id}`);
    if (document.startValidity) newFormData.append('startValidity', document.startValidity.toISOString());
    if (document.endValidity) newFormData.append('endValidity', document.endValidity.toISOString());
    if (document.amount) newFormData.append('amount', `${document.amount}`);
    if (document.reference) newFormData.append('reference', document.reference);

    return newFormData;
  };
}

export interface Document {
  id: number;
  documentId: number;
  name: string;
  mimetype: string;
  execution: Execution;
  issue: Issue;
  organisationType: OrganisationType;
  documentKind: DocumentKind;
  organisationId: number;
  organisationName: string;
  organisationUnitId: number;
  organisationUnitName: string;
  startValidity: Date;
  endValidity: Date;
  author: string;
  amount: number;
  reference: string;
  description?: string;
}
